/**
 * useDiscordAuth - Hook for Discord OAuth flow
 *
 * Read-only build: social linking has no backend. `initiateAuth` is an inert
 * no-op; `isAuthenticating` / `error` are still exported so pages that
 * destructure them keep working unchanged.
 */

import { useCallback, useState } from 'react';

/**
 * @param {Object} options - Configuration options
 * @returns {Object} - { isAuthenticating, error, initiateAuth }
 */
export const useDiscordAuth = (options = {}) => {
  const [isAuthenticating] = useState(false);
  const [error] = useState(null);

  const initiateAuth = useCallback(async () => {
    console.warn('[useDiscordAuth] Linking Discord is disabled on the read-only site.');
    return;
  }, []);

  return {
    isAuthenticating,
    error,
    initiateAuth,
  };
};

export default useDiscordAuth;
